import { cn } from '../../lib/utils.js';
import { AnimatePresence, motion } from 'motion/react';
import { useState, useCallback, useEffect } from 'react';

const FlipWords = ({ words, duration = 3000, className, }) => {
    const [currentWord, setCurrentWord] = useState(words[0]);
    const [isAnimating, setIsAnimating] = useState(false);
    // thanks for the fix Julian - https://github.com/Julian-AT
    const startAnimation = useCallback(() => {
        const word = words[words.indexOf(currentWord) + 1] || words[0];
        setCurrentWord(word);
        setIsAnimating(true);
    }, [currentWord, words]);
    useEffect(() => {
        if (!isAnimating)
            setTimeout(() => {
                startAnimation();
            }, duration);
    }, [isAnimating, duration, startAnimation]);
    return (React.createElement(AnimatePresence, { onExitComplete: () => {
            setIsAnimating(false);
        } },
        React.createElement(motion.div, { initial: {
                opacity: 0,
                y: 10,
            }, animate: {
                opacity: 1,
                y: 0,
            }, transition: {
                type: "spring",
                stiffness: 100,
                damping: 10,
            }, exit: {
                opacity: 0,
                y: -40,
                x: 40,
                filter: "blur(8px)",
                scale: 2,
                position: "absolute",
            }, className: cn("tw:z-10 tw:inline tw:relative tw:text-left", className), key: currentWord }, currentWord.split(" ").map((word, wordIndex) => (React.createElement(motion.span, { key: word + wordIndex, initial: { opacity: 0, y: 10, filter: "blur(8px)" }, animate: { opacity: 1, y: 0, filter: "blur(0px)" }, transition: {
                delay: wordIndex * 0.3,
                duration: 0.3,
            }, className: "tw:inline-block tw:whitespace-nowrap" },
            word.split("").map((letter, letterIndex) => (React.createElement(motion.span, { key: word + letterIndex, initial: { opacity: 0, y: 10, filter: "blur(8px)" }, animate: { opacity: 1, y: 0, filter: "blur(0px)" }, transition: {
                    delay: wordIndex * 0.3 + letterIndex * 0.05,
                    duration: 0.2,
                }, className: "tw:inline-block" }, letter))),
            React.createElement("span", { className: "tw:inline-block" }, "\u00A0")))))));
};

export { FlipWords };
//# sourceMappingURL=flip-words.js.map
